import React from "react";
import moment from "moment";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import { isRequiredQuestion } from "../../../../../../utils";
import {toGermanFormat} from "../../../../../../../../utils/numberFormater";
import RadioCard from "../../../formElement/RadioCard";
import SelectFormElementV2 from "../../../formElement/SelectFormElementV2";


const SelectProfileV2 = (props) => {
  const {
    onAnswerChange,
    dataService,
    questions: [esgAdvisorQuestion, esgProfileRadioQuestion, esgProfileSelectQuestion],
  } = props;

  const esgProfiles = React.useMemo(() =>
    _.take(
      dataService.esgProfiles.map((r) => {
        return {
          id: r.esgProfileGuid,
          value: r.esgProfileGuid,
          label: `ESG Profilierung vom ${moment(r.createdAt).format("DD.MM.YYYY")}: 
                  ÖKO ${toGermanFormat(r.targetEcoPct, undefined, '%', 2, true)}, 
                  ESG ${toGermanFormat(r.targetEsgPct, undefined, '%', 2, true)}, 
                  PAI ${toGermanFormat(r.targetPaiPct, undefined, '%', 2, true)}`
        };
      }),
      10
    )
  , [JSON.stringify(dataService.esgProfiles)]);

  const hasExistingProfiles = !_.isEmpty(esgProfiles);

  React.useEffect(() => {
    if (!esgAdvisorQuestion.answer) {
      handleAdvisorValueChange("yes");
    }
    if (!hasExistingProfiles) {
      const option = esgProfileRadioQuestion.options[2];
      option.disabled = true;
      option.info_text = 'Dieser Kunde/diese Kundin hat noch keine Nachhaltigkeitsprofilierung durchgeführt.'
    } else if (!esgProfileSelectQuestion.answer){
      handleProfileChange(getLatestESGProfile());
    }

  }, []);

  const handleProfileChange = (value) => {
    onAnswerChange(esgProfileSelectQuestion.uid, value);
  };

  const handleRadioValueChange = (value) => {
    onAnswerChange(esgProfileRadioQuestion.uid, value);
  };

  const handleAdvisorValueChange = (value) => {
    onAnswerChange(esgAdvisorQuestion.uid, value);
    esgAdvisorQuestion.optional = value;
  };

  const getLatestESGProfile = () => {
    return _.get(esgProfiles, "0.value", "");
  };

  const esgNotNeeded = esgAdvisorQuestion.answer === "no";
  const isProfileSelectDisabled = esgNotNeeded || esgProfileRadioQuestion.answer !== 'prefill';
  // in case it's disabled set it optional
  esgProfileSelectQuestion.optional = isProfileSelectDisabled;

  return (
    <Grid container spacing={3} style={{marginTop: 32}}>
      {!esgAdvisorQuestion.hidden && (
        <Grid item xs={12}>
          <Grid container justify={"center"}>
            <Grid item xs={6}>
              <RadioCard
                value={esgAdvisorQuestion.answer || ""}
                options={esgAdvisorQuestion.options}
                onChange={handleAdvisorValueChange}
                required={isRequiredQuestion(esgAdvisorQuestion)}
                newDesign
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid item xs={12}>
        <Grid container justify={"center"}>
          <Grid item xs={6}>
            <RadioCard
              value={esgProfileRadioQuestion.answer || ""}
              disabled={esgNotNeeded}
              options={esgProfileRadioQuestion.options}
              onChange={handleRadioValueChange}
              custom_classes={esgProfileRadioQuestion.custom_classes}
              required={isRequiredQuestion(esgProfileRadioQuestion)}
              newDesign
            />
          </Grid>
        </Grid>
      </Grid>
      {hasExistingProfiles && (
        <Grid item xs={12}>
          <Grid container justify={"center"}>
            <Grid item xs={6}>
              <SelectFormElementV2
                label={esgProfileSelectQuestion.question_text}
                value={esgProfileSelectQuestion.answer}
                options={esgProfiles}
                onChange={handleProfileChange}
                disabled={isProfileSelectDisabled}
                newDesign
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default SelectProfileV2;